var rich_content_viewer_default = {
  "fontElementMap": "_8RvXo",
  "wrapper": "XP7B5",
  "pluginContainerMobile": "AKUOA",
  "viewer": "BBJIt",
  "android": "xebi9",
  "rootedTraversedContent": "YjU7c",
  "atomic": "_92Gu0",
  "toolbar": "_-7wuV",
  "block": "UIsQU"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
